import React, {Component} from 'react';

import EdapViewTracker from '../../components/common/edap-view-tracker/EdapViewTracker';
import {reactCarouselBreakPoints} from '../../utils/carousel-breakpoints';

import {TESTS} from '../../utils/abacus';
import MvtTest from '../../components/common/mvt/MvtTest/MvtTest';
import {IS_BROWSER} from '../../utils/dynamic-rendering';

import {Card} from './components/Card';
import {CardCarousel} from '../../components/common/carousel/Carousel';

import './styles.less';

function getCards({isMobile, data, translations, pushHandlerClickData, lbsId}) {
    const {readMore} = translations;
    return data.map((item, index) => {
        const {
            heroUrl,
            overview,
            headline,
            metaDescription,
            path,
            heroTitle,
        } = item;

        const description = overview || metaDescription;

        return (
            <a
                key={index}
                href={path}
                target="_blank"
                onClick={pushHandlerClickData(headline, lbsId)}
            >
                <Card
                    isMobile={isMobile}
                    title={headline}
                    imgUrl={`${heroUrl}?w=228&h=128`}
                    overview={description}
                    readMore={readMore}
                    path={path}
                    altText={heroTitle}
                />
            </a>
        );
    });
}

function getEventData({ACTION_LOCATION, contentful, breakPoints}) {
    if (!IS_BROWSER) {
        return {};
    }
    const width = window.innerWidth;

    const selectedKey = Object.keys(breakPoints)
        .sort((a, b) => b - a)
        .find((key) => width >= Number(key));

    const count = breakPoints[selectedKey];

    const displayedCount =
        count < contentful.length ? count : contentful.length;

    const displayedTitles = contentful
        .slice(0, displayedCount)
        .map(({headline}) => headline)
        .join(',');

    const allCardsLoaded = contentful.map(({headline}) => headline).join(',');

    return {
        action_location: ACTION_LOCATION,
        content_type: 'seo',
        number_cards_loaded: contentful.length,
        card_titles_loaded: allCardsLoaded,
        number_cards_displayed: displayedCount,
        card_titles_displayed: displayedTitles,
    };
}

class ContentHubComponent extends Component {
    render() {
        const {
            contentHubData: {contentful, translations},
            isMobile,
            pushHandleNextData,
            pushHandlePrevData,
            pushHandlerClickData,
            lbsId,
            ACTION_LOCATION,
            showContentHub,
        } = this.props;

        if (!contentful.length) {
            return null;
        }

        if (!showContentHub) {
            return (
                <React.Fragment>
                    <MvtTest test={TESTS.CONTENT_HUB_SLP} />
                    <MvtTest test={TESTS.CONTENT_HUB_SLP_TRAFFIC}>
                        <div />
                    </MvtTest>
                </React.Fragment>
            );
        }

        const cards = getCards({
            isMobile,
            data: contentful,
            translations,
            pushHandlerClickData,
            lbsId,
        });

        const cardNumber =
            cards.length < 4 ? `card-carousel-${cards.length}` : '';
        const carouselClassName = `card-carousel ${cardNumber}`;

        const breakPoints = {
            1600: 4,
            1200: 4,
            992: 3,
            768: 3,
            480: 2,
            0: isMobile ? 2 : 4,
        };

        const edapEvent = 'content_module.presented';

        return (
            <React.Fragment>
                <MvtTest test={TESTS.CONTENT_HUB_SLP_TRAFFIC} />
                <MvtTest test={TESTS.CONTENT_HUB_SLP}>
                    <div className="container module module--no-padding content-hub-carousel">
                        <div className={carouselClassName}>
                            <CardCarousel
                                breakpoints={reactCarouselBreakPoints(
                                    isMobile,
                                    breakPoints
                                )}
                                isMobile={isMobile}
                                titleMessage={translations.heading}
                                onNextClick={pushHandleNextData}
                                onPreviousClick={pushHandlePrevData}
                            >
                                {cards}
                            </CardCarousel>
                        </div>
                        <EdapViewTracker
                            edapEvent={edapEvent}
                            eventData={getEventData({
                                ACTION_LOCATION,
                                contentful,
                                breakPoints,
                            })}
                        />
                    </div>
                </MvtTest>
            </React.Fragment>
        );
    }
}

export default ContentHubComponent;
